import React, { useEffect, useState } from "react";
import { colors, imageMap } from "../utils/constants";
import { isBefore, isSameDay, differenceInMonths } from 'date-fns';
import { db } from "../firebase-config";
import { addDoc, collection, doc, getCountFromServer, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";
import BackButton from '../assets/Back.png'
import { getFirebaseDocs, getUrlParams, preserveLatestValuesInBooking, randomString } from "../utils/common";
import ModalComponent from "../components/Modal";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from "react-redux";
import { clearBookings, setBookings } from "../redux/bookingReducer";

const SelectRide = () => {

    const [dayRides, setDayRides] = useState([])
    const [timeSlots, setTimeslots] = useState([])
    const [mode, setMode] = useState('RideView')  //RideView and TimeView
    const [chosenRide, setChosenRide] = useState()
    const [showTimeConfirmation, setShowTimeConfirmation] = useState(false)
    const [pendingBookings, setPendingBookings] = useState([])
    const [pastBookings, setPastBookings] = useState([])
    const [date, setDate] = useState()
    const [userData, setUserData] = useState()
    const [showPremiumRidePopup, setShowPremiumRidePopup] = useState()
    const [rideTimeFromCart, setRideTimeFromCart] = useState()

    const bookings = useSelector((state) => state.bookings.value)

    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()

    const userId = window.localStorage.getItem('config:userId')

    console.log('userId', userId)

    useEffect(() => {
        if (!userId && window.location.pathname !== '/') {
            navigate('/')
        } else {
            getRides()
            getUserData()
        }
    }, [])

    useEffect(() => {

        if (dayRides.length > 0) {
            // console.log('location.state', dayRides, location.state.id)
            const rideIdFromCart = location.state && location.state.id.split('-')[0]
            const rideTimeFromCartUrl = location.state && location.state.id

            if (rideIdFromCart) {
                setRideTimeFromCart(rideTimeFromCartUrl.split('-')[2])
                setChosenRide(dayRides.find(({ id }) => id === rideIdFromCart))
                navigate(location.pathname + location.search, { replace: true });
            }
        }
    }, [dayRides])


    useEffect(() => {
        if (chosenRide) {
            getTimeslots()
        } else {
            setMode('RideView')
        }
    }, [chosenRide])


    const getUserData = async () => {
        const existingDoc = await (await getDoc(doc(db, 'users', userId))).data()
        setUserData(existingDoc)
    }



    const getTimeslots = async () => {
        const timeslotData = await (await getDoc(doc(db, 'timeslots', `${chosenRide.id}-${date}`))).data()
        if (!timeslotData) {
            setMode('RideView')
            return
        }

        // Perform quantity reached and time in past check.
        const updatedTimeslotData = await Promise.all(timeslotData.times.map(async (row) => {
            if (row.available) {
                const resp = await getCountFromServer(await query(collection(db, 'bookings'), where('rides', 'array-contains', `${chosenRide.id}-${date}-${row.name}`)))
                const count = await resp.data().count
                // const quantityToCheckWith = isSameDay(new Date(), new Date(2023, 6, parseInt(date))) ? row.capacity : row.quantity
                const quantityToCheckWith = row.quantity
                if (count >= quantityToCheckWith || isBefore(new Date(row.start * 1000), new Date())) {
                    return { ...row, available: false }
                }
                return row
            }
            return row
        }))

        setTimeslots(updatedTimeslotData)
        setMode('TimeView')
    }

    const getRides = async () => {
        const params = getUrlParams()
        if (!params.dt) {
            navigate('/')
            return
        }

        // await setDoc(doc(db, 'rides', '29'), {
        //     data: [
        //         { id: 'ninja', name: 'Ninja Warped Wall', desc: '(6 - 16 years)' },
        //         { id: 'ard_4', name: 'Adrenaline Rush 4', desc: '(6 - 16 years)' },
        //         { id: 'ard_ext', name: 'Adrenaline Rush Extreme', desc: '(6 - 16 years)' },
        //         { id: 'kids_gym', name: 'Kids Gym', desc: '(3 - 6 years)' },
        //         { id: 'castle', name: '5 in 1 Jumping Castle', desc: '(3 - 7 years)' },
        //         { id: 'playland', name: 'Soft Child\'s Playland', desc: '(1 - 3 years)' },
        //         { id: 'bull', name: 'Bucking Bull', desc: '(6 - 16 years)' },
        //         { id: 'zoo', name: 'Zoo maze', desc: '(3 - 12 years)' },
        //         { id: 'chair', name: 'Chair O\'Plane', desc: '(3 - 16 years)' },
        //         { id: 'pony', name: 'Lead Pony Ride', desc: '' },
        //         { id: 'laser', name: 'Laser Skirmish Game ', desc: '' },
        //         { id: 'face', name: 'Face Painting', desc: '' },
        //         { id: 'farm', name: 'Petting Farm', desc: '' },
        //         { id: 'stunt', name: 'Stunt Jump', desc: '', premium: true },
        //         { id: 'rock_wall', name: 'Rock Wall', desc: '', premium: true },
        //         { id: 'slide', name: 'Giant Slide', desc: '', premium: true },
        //     ]
        // })

        // const data = [
        //     { id: 'ninja', name: 'Ninja Warped Wall', desc: '(6 - 16 years)' },
        //     { id: 'ard_4', name: 'Adrenaline Rush 4', desc: '(6 - 16 years)' },
        //     { id: 'ard_ext', name: 'Adrenaline Rush Extreme', desc: '(6 - 16 years)' },
        //     { id: 'kids_gym', name: 'Kids Gym', desc: '(3 - 6 years)' },
        //     { id: 'castle', name: '5 in 1 Jumping Castle', desc: '(3 - 7 years)' },
        //     { id: 'playland', name: 'Soft Child\'s Playland', desc: '(1 - 3 years)' },
        //     { id: 'bull', name: 'Bucking Bull', desc: '(6 - 16 years)' },
        //     { id: 'zoo', name: 'Zoo maze', desc: '(3 - 12 years)' },
        //     { id: 'chair', name: 'Chair O\'Plane', desc: '(3 - 16 years)' },
        //     { id: 'pony', name: 'Lead Pony Ride', desc: '' },
        //     { id: 'laser', name: 'Laser Skirmish Game ', desc: '' },
        //     { id: 'face', name: 'Face Painting', desc: '' },
        //     { id: 'farm', name: 'Petting Farm', desc: '' },
        //     { id: 'stunt', name: 'Stunt Jump', desc: '', premium: true },
        //     { id: 'rock_wall', name: 'Rock Wall', desc: '', premium: true },
        //     { id: 'slide', name: 'Giant Slide', desc: '', premium: true },
        // ]

        // console.log(data.map(({ id }) => ({ id, capacity: 45, reserve: 27 })))

        // const initialTimestamp = 1690587900 // 29 Jul 2023 9:45 am seconds
        // const date = '-29'
        // const initialTimestamp = 1690674300 // 30 Jul 2023 9:45 am seconds
        // const date = '-30'
        // const finalTimestamp = 1690609500 // 29 Jul 2023 3:45 pm seconds
        // const duration = 900 // 15 mins - in seconds
        // console.log((1690609500 - 1690587900) / 15)
        // let count = 25

        // const names = ['9:00am']
        // const timeslotObjs = [
        //     {
        //         "id": "ninja",
        //         "capacity": 25,
        //         "reserve": 15
        //     },
        //     {
        //         "id": "ard_4",
        //         "capacity": 45,
        //         "reserve": 27
        //     },
        //     {
        //         "id": "ard_ext",
        //         "capacity": 45,
        //         "reserve": 27
        //     },
        //     {
        //         "id": "kids_gym",
        //         "capacity": 40,
        //         "reserve": 24
        //     },
        //     {
        //         "id": "castle",
        //         "capacity": 25,
        //         "reserve": 15
        //     },
        //     {
        //         "id": "playland",
        //         "capacity": 19,
        //         "reserve": 12
        //     },
        //     {
        //         "id": "bull",
        //         "capacity": 55,
        //         "reserve": 33
        //     },
        //     {
        //         "id": "zoo",
        //         "capacity": 45,
        //         "reserve": 27
        //     },
        //     {
        //         "id": "chair",
        //         "capacity": 95,
        //         "reserve": 57
        //     },
        //     {
        //         "id": "pony",
        //         "capacity": 120,
        //         "reserve": 72
        //     },
        //     {
        //         "id": "laser",
        //         "capacity": 35,
        //         "reserve": 21
        //     },
        //     {
        //         "id": "face",
        //         "capacity": 30,
        //         "reserve": 18
        //     },
        //     {
        //         "id": "farm",
        //         "capacity": 145,
        //         "reserve": 87
        //     },
        //     {
        //         "id": "stunt",
        //         "capacity": 45,
        //         "reserve": 27
        //     },
        //     {
        //         "id": "rock_wall",
        //         "capacity": 20,
        //         "reserve": 12
        //     },
        //     {
        //         "id": "slide",
        //         "capacity": 40,
        //         "reserve": 24
        //     }
        // ]


        // for (let timeslotObj of timeslotObjs) {

        //     let times = []
        //     for (let ct = 0; ct < 25; ct++) {
        //         const start = initialTimestamp + (ct * duration)
        //         const end = initialTimestamp + ((ct + 1) * duration)
        //         times.push({ quantity: timeslotObj.reserve, capacity: timeslotObj.capacity, available: true, start, end, name: format(new Date(start*1000),'hh:mm a') })
        //     }

        //     console.log(times)

        //     await setDoc(doc(db, 'timeslots', timeslotObj.id + date), {
        //         times
        //     })
        // }

        setDate(params.dt)
        const rides = await (await getDoc(doc(db, 'rides', params.dt))).data()
        if (!rides) {
            navigate('/')
            return
        }

        setDayRides(rides.data.filter(r => !r.disabled))

        if (!bookings) {
            fetchPendingBookings()
        } else {
            setPendingBookings(bookings)
        }
    }


    // const fetchPastBookings = async () => {
    //     const existingBookings = await getFirebaseDocs(await getDocs(await query(collection(db, 'bookings'), where('userId', '==', userId))))
    //     if (existingBookings.length > 0) {
    //         setPastBookings(existingBookings.map(row => row.rides).flat())
    //     }
    // }


    const fetchPendingBookings = async () => {

        const pending_booking_id = window.localStorage.getItem(`config:pending_booking_id-${userId}`)
        let pending_and_past_bookings = []

        const existingBookings = await getFirebaseDocs(await getDocs(await query(collection(db, 'bookings'), where('userId', '==', userId))))
        if (existingBookings.length > 0) {
            let localPastbookings = existingBookings.map(row => row.rides).flat()
            pending_and_past_bookings = localPastbookings
            // setPastBookings(localPastbookings)
        }

        if (pending_booking_id) {
            const existingBooking = await (await getDoc(doc(db, 'pending_bookings', pending_booking_id))).data()
            if (existingBooking) {
                // setPendingBookings(existingBooking.rides)
                pending_and_past_bookings = [...pending_and_past_bookings, ...existingBooking.rides]
            }
        }

        dispatch(setBookings(preserveLatestValuesInBooking(pending_and_past_bookings)))
        setPendingBookings(preserveLatestValuesInBooking(pending_and_past_bookings))
    }

    const addTimeToCart = async () => {
        // Add ride, day, time to cart.
        const newRide = `${chosenRide.id}-${date}-${showTimeConfirmation.name}`
        // const pending_booking_id = window.localStorage.getItem(`config:pending_booking_id-${userId}`)
        // let modifiedSameRide = false
        // if (pending_booking_id) {
        //     const existingBooking = await (await getDoc(doc(db, 'pending_bookings', pending_booking_id))).data()
        //     if (existingBooking) {
        //         if (existingBooking.rides.filter(v => v.includes(`${chosenRide.id}-${date}`)).length > 0) {
        //             modifiedSameRide = true
        //         }
        //         await setDoc(doc(db, 'pending_bookings', pending_booking_id), { rides: [...existingBooking.rides.filter(v => !v.includes(`${chosenRide.id}-${date}`)), newRide], userId })
        //     } else {
        //         await createNewPendingBooking(newRide)
        //     }
        // } else {
        //     await createNewPendingBooking(newRide)
        // }

        let modifiedSameRide = false
        const pending_booking_id = window.localStorage.getItem(`config:pending_booking_id-${userId}`)

        if (pending_booking_id && pendingBookings.filter(row => (row.split('-')[0] + '-' + row.split('-')[1]) === `${chosenRide.id}-${date}`).length > 0) {
            modifiedSameRide = true
            // Pushing pending items to cart filtering out existing past bookings
            // const pendingBookingsDontIncludingPast = pendingBookings.filter(row => !pastBookings.includes(row))
            await setDoc(doc(db, 'pending_bookings', pending_booking_id), { rides: [...pendingBookings.filter(v => (v.split('-')[0] + '-' + v.split('-')[1]) !== `${chosenRide.id}-${date}`), newRide], userId })
        } else {
            await createNewPendingBooking(newRide, pending_booking_id || randomString())
        }

        setShowTimeConfirmation(false)
        setChosenRide()
        setMode('RideView')
        toast.success(modifiedSameRide ? 'Ride updated!' : 'Ride added!', { position: 'top-center' })
        await fetchPendingBookings()
    }

    const createNewPendingBooking = async (newRide, id) => {
        // const pendingBookingsDontIncludingPast = pendingBookings.filter(row => !pastBookings.includes(row))
        const resp = await setDoc(doc(db, 'pending_bookings', id), { rides: [...pendingBookings, newRide], userId })
        window.localStorage.setItem(`config:pending_booking_id-${userId}`, id)
    }


    const checkIfAlreadyBooked = rideId => {
        return !!pastBookings.find(ride => ride.split('-')[0] === rideId)
    }

    const checkIfNotAgeAppropriate = rideDesc => {
        if (!rideDesc || !userData) {
            return false
        }
        const splitText = rideDesc && rideDesc.split(' ')
        const minAgeMonths = parseInt(splitText[0].replace('(', '')) * 12
        const maxAgeMonths = parseInt(splitText[2]) * 12 + 11 // add 11 months to allow till end of that year
        // return !!pastBookings.find(ride => ride.split('-')[0] === rideId)
        const babyAgeInMonths = differenceInMonths(new Date(), new Date(userData.date))
        return (babyAgeInMonths < minAgeMonths || babyAgeInMonths > maxAgeMonths)
        // new Date(userData.date)
    }


    const handleRideClick = (ride) => {
        if (!ride.premium) {
            setChosenRide(ride)
        } else {
            setShowPremiumRidePopup(ride)
        }
    }


    return (<div className="container">

        <div tabIndex={0}>
            <img src={BackButton} className="back-button" onClick={() => mode === 'RideView' ? navigate('/pickDate') : setChosenRide()} />
        </div>

        <h2 style={{ margin: '-40px auto 20px', color: colors.red }}>{mode === 'RideView' ? 'Select your Ride' : 'Select your Time'}</h2>
        {mode === 'RideView' && <h4 style={{ textAlign: 'center' }}>Once you book your rides, click "View Cart" to proceed to confirmation.</h4>}

        {mode === 'RideView' && <button disabled={pendingBookings.length === 0} onClick={() => navigate(`/checkout?dt=${date}`)}>View Cart {pendingBookings.length > 0 && `(${pendingBookings.length})`}</button>}

        {chosenRide && mode === 'TimeView' && <>
            <h3 style={{ textAlign: 'center', fontSize: '21px' }}>{chosenRide.name}</h3>
            <img src={imageMap[chosenRide.id]} style={{ borderRadius: '10px', width: '95%', margin: '20px auto', maxWidth: '500px' }} />
        </>
        }

        {mode === 'RideView' &&
            <>
                {dayRides.map(ride => <div key={ride.id} className={(checkIfNotAgeAppropriate(ride.desc)) ? 'ride-row disabled ' : 'ride-row hover'} onClick={() => !(checkIfNotAgeAppropriate(ride.desc)) && handleRideClick(ride)} tabIndex={0}>
                    <img src={imageMap[ride.id]} />
                    <h2>{ride.name}</h2>
                    <p>{ride.desc}</p>
                </div>)}
                <button disabled={pendingBookings.length === 0} onClick={() => navigate(`/checkout?dt=${date}`)}>View Cart {pendingBookings.length > 0 && `(${pendingBookings.length})`}</button>
            </>
        }


        <div className="timeslots-wrapper">
            {mode === 'TimeView' && <>
                {timeSlots.map(time => <button key={time.start} style={{ color: rideTimeFromCart && rideTimeFromCart === time.name ? 'green' : 'white' }} disabled={!time.available} onClick={() => setShowTimeConfirmation(time)}>{time.name}</button>)}
            </>}
        </div>


        <ModalComponent showModal={!!showPremiumRidePopup} setShowModal={setShowPremiumRidePopup}>
            <> <h2 style={{ textAlign: 'center' }}>Premium Ride</h2>
                <p style={{ textAlign: 'center', marginTop: 0 }}>These rides are only available by pre-purchase. Please <a href={date === '29' ? 'https://www.eventbrite.com.au/e/horses-birthday-kids-festival-2023-saturday-tickets-336929734907' : 'https://www.eventbrite.com.au/e/horses-birthday-kids-festival-2023-sunday-tickets-336955241197'} target="_blank">click here</a> to purchase your premium ride ticket before booking in your time slot.</p>
                <div style={{ display: 'flex' }}>
                    <button onClick={() => { setChosenRide(showPremiumRidePopup); setShowPremiumRidePopup(false) }}>Continue</button>
                    <button className="secondary-button" onClick={() => setShowPremiumRidePopup(false)}>Cancel</button>
                </div></>
        </ModalComponent>

        <ModalComponent showModal={!!showTimeConfirmation} setShowModal={setShowTimeConfirmation}>
            {chosenRide && <> <h2 style={{ textAlign: 'center' }}>Add {chosenRide.name} at {showTimeConfirmation.name} to your day?</h2>
                <div style={{ display: 'flex' }}>
                    <button onClick={addTimeToCart}>Continue</button>
                    <button className="secondary-button" onClick={() => setShowTimeConfirmation(false)}>Cancel</button>
                </div></>}
        </ModalComponent>

    </div>)
}

export default SelectRide